import { REDUCE_DATING_COUNT, SET_CURRENT_PROFILE } from "./action-types";

export const reduceDatingCount = () => ({ type: REDUCE_DATING_COUNT});

export const setCurrentProfile = (profile = {}) => ({ type: SET_CURRENT_PROFILE, payload: profile });
